<template>
  <div class="simple-city-software-input-with-optional-heading">
    <h5 v-if="heading">{{ heading }}</h5>
    <div
      class="input-wrapper"
      :class="
        error
          ? 'simple-city-software-input error'
          : 'simple-city-software-input'
      "
    >
      <p class="prefix" v-if="prefix">{{ prefix }}</p>
      <input
        :type="type ? type : 'text'"
        :disabled="disabled"
        :placeholder="placeholder"
        v-model="data"
        @blur="blur()"
        @focus="focus"
      />
      <p class="suffix" v-if="suffix">{{ suffix }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(e) {
        this.value = e;
        this.$emit("scs-input", this.value);
      },
    },
  },
  methods: {
    blur() {
      this.$emit("scs-blur");
    },
    focus($event) {
      this.$emit("scs-focus", $event);
    },
  },
  created() {
    if (this.initialValue) {
      this.value = this.initialValue;
    }
  },
  watch: {
    initialValue() {
      this.value = this.initialValue;
    },
  },

  components: {},
  // todo : create number input for better styling
  emits: ["scs-input", "scs-blur", "scs-focus"],
  props: [
    "heading",
    "placeholder",
    "initialValue",
    "disabled",
    "type",
    "error",
    "suffix",
    "prefix",
  ],
};
</script>
<style scoped>
.simple-city-software-input-with-optional-heading {
  display: flex;
  width: fit-content;
  flex-direction: column;
  align-items: center;

  max-width: 300px;
}

h5 {
  margin: 10px;
  width: 90%;
  text-align: left;
}

p {
  padding: 0;
  max-width: 75%;
  overflow-wrap: break-word;
  text-align: right;
  margin: none;
}
.input-wrapper {
  border: 1px solid var(--secondaryColor);
  background-color: var(--backgroundColor);
  border-radius: 4px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 0.85rem;
  margin: 2px;
  padding: 3px;
}
input {
  color: var(--contrastColor);
  background-color: var(--backgroundColor);
  border: none;
  padding: 5px;
  margin: 5px;
  outline: none;
  text-align: center;
  font-family: Raleway;
  /* height: 17px; */
  /* height: 100%; */
  width: 100%;
}

.input:has(input:focus) {
  outline: none;
  filter: drop-shadow(0 0 4px var(--secondaryColor));
}
.error {
  border: 1px solid red;
}

@media print {
  #application-header {
    display: none;
  }

  input {
    padding: 0;
    outline: none;
    font-size: 1rem;
  }
}
</style>
